var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3577_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8011 2.63152C23.6634 2.12289 23.395 1.65919 23.0224 1.28659C22.6498 0.913989 22.1861 0.645494 21.6775 0.507838C19.8154 0 12.3212 0 12.3212 0C12.3212 0 4.82658 0.015372 2.96451 0.52321C2.45588 0.660874 1.99218 0.929383 1.6196 1.302C1.24701 1.67462 0.978544 2.13834 0.840925 2.64698C0.277691 5.95552 0.0592028 10.997 0.856391 14.1732C0.994024 14.6818 1.2625 15.1455 1.63508 15.5181C2.00766 15.8907 2.47135 16.1592 2.97998 16.2968C4.84205 16.8047 12.3365 16.8047 12.3365 16.8047C12.3365 16.8047 19.8308 16.8047 21.6928 16.2968C22.2014 16.1592 22.6651 15.8907 23.0377 15.5181C23.4103 15.1455 23.6788 14.6818 23.8164 14.1732C24.4105 10.8599 24.5936 5.82158 23.8011 2.63152Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93579 12.0032L16.1528 8.40225L9.93579 4.80127V12.0032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3577_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.8717,
    fill: "white",
    transform: "translate(0.333252)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.79888f09913414a42633fcbacb79a9f7.svg";
export { ForwardRef as ReactComponent };